import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MobileCenteredLayout } from '@/components/MobileCenteredLayout/MobileCenteredLayout';
import { getStoredInviteToken } from '@/helpers/inviteToken';
import { IDENTIFY_NAMESPACE } from '@/i18n';
import { useIdentify } from '@/Pages/Identify/hooks/useIdentify';

export function IdentifyPage(): JSX.Element {
  const { t } = useTranslation(IDENTIFY_NAMESPACE);
  const {
    document,
    notFound,
    isSubmitting,
    isSubmitEnabled,
    setDocument,
    submit,
  } = useIdentify();

  // Convite por link único (/link/<token>): a identificação é pelo token.
  if (getStoredInviteToken() !== null) {
    return <Navigate to="/invite" replace />;
  }

  return (
    <MobileCenteredLayout>
      <Box
        component="main"
        data-testid="identify-page-main"
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, py: 4 }}
      >
        <Box component="header">
          <Typography component="h1" variant="h5">
            {t('title')}
          </Typography>
          <Typography component="p" variant="body2" color="text.secondary">
            {t('subtitle')}
          </Typography>
        </Box>

        <Box
          component="form"
          onSubmit={(event) => {
            event.preventDefault();
            void submit();
          }}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField
            label={t('cpfLabel')}
            placeholder={t('cpfPlaceholder')}
            value={document}
            onChange={(event) => setDocument(event.target.value)}
            inputProps={{ inputMode: 'numeric', 'data-testid': 'identify-document' }}
            fullWidth
          />

          {notFound && (
            <Alert severity="error" data-testid="identify-not-found">
              {t('notFoundMessage')}
            </Alert>
          )}

          <Button
            type="submit"
            variant="contained"
            size="large"
            disabled={!isSubmitEnabled || isSubmitting}
            data-testid="identify-submit"
          >
            {isSubmitting ? t('ctaLoading') : t('cta')}
          </Button>
        </Box>
      </Box>
    </MobileCenteredLayout>
  );
}
